import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const money = (n) => `${Number(n || 0).toLocaleString("fr-CA", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} $`;

// Accueil : payeurs manuels invités au prélèvement 28 j → combien ont activé, revenu récurrent gagné.
export function SubscriptionActivationCard() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/ops/audit/subscription-links/stats").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d || !d.contacted) return null;
  const st = { completed: ["✓ activé", "text-emerald-300"], open: ["lien envoyé", "text-sky-300"], expired: ["lien expiré", "text-zinc-500"] };
  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mt-4 rounded-xl border border-[#C9A961]/40 bg-[#C9A961]/[0.05] p-4" data-testid="subscription-activation-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#C9A961] font-semibold">Prélèvement automatique 28 j · payeurs manuels invités</p>
          <h3 className="text-zinc-100 font-bold mt-0.5" data-testid="subscription-activation-title">{d.activated} sur {d.contacted} ont activé leur prélèvement ({d.rate_pct} %)</h3>
          <p className="text-xs text-zinc-400 mt-0.5" data-testid="subscription-activation-hint">Récurrent gagné : <b className="text-emerald-300">{money(d.monthly)}/mois</b> ≈ {money(d.yearly)}/an · potentiel si tous activent : {money(d.potential_monthly)}/mois · {d.pending} en attente</p>
        </div>
        <button onClick={() => setOpen((v) => !v)} className="px-3 py-1.5 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-xs text-zinc-200" data-testid="subscription-activation-toggle">{open ? "Masquer" : "Voir qui"}</button>
      </div>
      {open && (
        <ul className="mt-3 text-xs divide-y divide-zinc-800/70" data-testid="subscription-activation-list">
          {d.rows.map((r) => <li key={r.customer_id} className="py-1 flex justify-between gap-2"><span className="text-zinc-200">{r.name || r.email} <span className="text-zinc-500">· invité le {r.first_sent}{r.reminded ? " · rappel J+3" : ""}{r.activated_at ? ` · activé le ${r.activated_at}` : ""}</span></span><span className={(st[r.status] || st.open)[1]}>{(st[r.status] || st.open)[0]} · {Number(r.amount).toFixed(2)} $/28 j</span></li>)}
        </ul>
      )}
    </div>
  );
}
